import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class SharedDossiersPanel extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            is_internal:false,
            all: [],
            selectedStatusIndex: 1,
            statuses: [],
            status: 'Externos',
            statusDossiers: null,
            search:'',
            page: 1,
            total: 0,
            dossierType:1,
            maxRecords: props.top,
            orderBy : {value: 'date', dir: 'desc', text: 'Por fecha - Mas Recientes' },
            orderOptions : [
                {value: 'date', dir: 'desc', text: 'Por fecha - Mas Recientes' },
                {value: 'date', dir: 'asc', text: 'Por Fecha - Mas Antiguos' },
                {value: 'fiscal_name', dir: 'asc', text: 'Por Nombre A - Z' },
                {value: 'fiscal_name', dir: 'desc', text: 'Por Nombre Z - A' },
            ],
        };
        this.loadStatus = this.loadStatus.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
    }

    changeOrderOption(option){
        this.setState({orderBy: option}, function(){
            this.getAll();
        });
    }

    componentDidMount() {
        const { lang } = this.context; 
        this.getStatuses();
            const hash = window.location.hash;
            let status = '';
            let dossierType = 0;
            switch (hash) {
            case '#ts_0':
                status = lang.get('messages.externos');
                dossierType = 1;
                break;
            case '#ts_1':
                status = lang.get('messages.internos');
                dossierType = 2;
                break;
            case '#ts_2':
                status = lang.get('messages.propios');
                dossierType = 3;
                break;
            default:
                status = lang.get('messages.externos');
                dossierType = 1;
                break;
            }
            this.setState({ status, dossierType }, () => {
            this.getAll();
            });
    }

    handleChange(e){
        this.setState({all: [], search: e.target.value, page: 1}, function () {
            this.getAll();
        });
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getAll();
        });
    }

    async getStatuses(){
        const res = await axios.get('/api/shared_dossiers/status')
        const data = res.data; 
        this.setState({statuses: data});

        var statusDossiers = [];
        this.state.statuses.map((s) => {
            statusDossiers = [...statusDossiers, []];
        });
        this.setState({statusDossiers: statusDossiers})
    }

    showAll(){
        this.setState({all: [], page: 1, status: null, index: null}, () => {
            this.getAll();
        });
    }

    loadStatus(index){
        this.setState({ selectedStatusIndex: index });
        const status = this.state.statuses[index];
        this.setState({all: [], total:0, page: 1, status: status.id,   dossierType: status.dossierType,is_internal: status.is_internal}, () => {
            this.getAll();
        });
    }

    async getAll(){
        var url = '/api/clients/shared_dossiers';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        if(this.state.status!=null){
            query.append('status', this.state.status);
        }
        query.append('dossierType', this.state.dossierType);
        if(this.state.orderBy.value != ''){
            query.append('orderBy', this.state.orderBy.value);
            query.append('orderByDir', this.state.orderBy.dir);

        }

        query.append('is_internal', this.state.is_internal);

        const qs = query.toString();
        url = url + `?${qs}`;
        url = url.endsWith('/') ? url.slice(0, -1) : url;
        const res = await axios.get(url);
        const data = res.data.data;
        this.setState({all: data, total: res.data.total});
    }

    getDossierTypeColor(type_id){
        if(type_id == 1) return 'danger'; // Nacional
        if(type_id == 2) return 'success'; // Internacional
        if(type_id == 3) return 'info'; // Especiales
        if(type_id == 4) return 'warning'; // Otros
    }

    render() {
        const { lang } = this.context; 
        return (
            
            <>
            <div className="card card-custom gutter-b my-5">
                <div className="card-header border-0 pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.compartidos')}</span>
                        <span className="text-muted mt-3 font-weight-bold font-size-sm">{this.state.total} {lang.get('messages.expedientes')}</span>
                    </h3>
                    <div className="card-toolbar">
                        <div>
                            {this.props.dashboard=="false" &&
                                <div className="input-icon mb-4">
                                    <input
                                        style={{width:'400px'}}
                                        onChange={this.handleChange}
                                        name="search"
                                        type="text"
                                        className="form-control"
                                        placeholder={lang.get('messages.buscar_expedientes_compartidos')} />
                                    <span>
                                        <i className="flaticon2-search-1 text-primary icon-md"></i>
                                    </span>
                                </div>
                            }
                            <ul className="nav nav-pills nav-pills-sm nav-dark justify-content-end">
                                {this.state.statuses.map((status, i) => {
                                    return <li key={i} className="nav-item ml-0" onClick={() => this.loadStatus(i)} >
                                        <a href={"#ts_" + i } className={`nav-link py-2 px-4 font-weight-bolder font-size-sm ${this.state.dossierType==status.id ? "active" : ""}`}>
                                             {status.name}
                                            </a>
                                    </li>
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card-body pt-1">
                    <div className="table-responsive">
                        <table className="table table-borderless table-vertical-center">
                        {this.props.dashboard=="true" &&
                            <tbody>
                                {this.state.all.map((d, index) => {
                                    return <tr key={index}>
                                        <td className="pl-0 py-5">
                                            <div className="symbol symbol-40">
                                                <div className={"symbol-label text-white font-weight-bolder bg-"+this.getDossierTypeColor(d.dossier?.dossier_type_id)}>
                                                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.534 14.2957C11.3803 14.0809 11.2242 13.8686 11.073 13.6513C11.0284 13.5854 10.9962 13.5903 10.9541 13.6464C10.7731 13.8954 10.5947 14.1468 10.4138 14.3982C10.3865 14.4373 10.3692 14.4837 10.3147 14.4959C10.2577 14.5105 10.2502 14.4788 10.2552 14.4349C10.28 14.2786 10.3221 14.1273 10.332 13.9686C10.3419 13.7758 10.3741 13.583 10.394 13.3901C10.4311 12.9874 10.4931 12.5846 10.5352 12.1819C10.5699 11.8255 10.617 11.4716 10.6542 11.1152C10.6815 10.8736 10.7013 10.6295 10.731 10.3878C10.7731 10.051 10.7979 9.70926 10.8574 9.37242C10.8896 9.19179 10.8896 9.00872 10.9119 8.8281C10.9342 8.64015 10.959 8.44976 10.9813 8.25937C11.0433 7.74189 11.0978 7.22686 11.1548 6.70939C11.1796 6.47995 11.1994 6.24806 11.2292 6.01862C11.2539 5.8087 11.2688 5.59878 11.301 5.3913C11.3332 5.20335 11.3556 5.01296 11.3655 4.82257C11.3754 4.65903 11.4076 4.50037 11.4473 4.34416C11.4596 4.33439 11.472 4.32463 11.4844 4.31487C11.5736 4.33195 11.5984 4.41494 11.6381 4.47596C11.8686 4.81281 12.1263 5.13257 12.3568 5.46941C12.6344 5.87704 12.9293 6.27491 13.2143 6.67522C13.6133 7.23419 14.0123 7.79071 14.4212 8.34236C14.5377 8.50102 14.6393 8.667 14.7583 8.82322C14.9045 9.01361 15.0185 9.22841 15.1945 9.39439C15.2168 9.41391 15.2242 9.44321 15.2391 9.46761C15.2267 9.61651 15.3506 9.69706 15.4225 9.7947C15.6777 10.1364 15.9157 10.4904 16.1684 10.8321C16.4534 11.2177 16.7409 11.601 17.0111 11.9939C17.3184 12.4406 17.643 12.8751 17.9578 13.3169C18.4287 13.9784 18.8995 14.6423 19.3729 15.3014C19.9256 16.0703 20.4832 16.8343 21.0358 17.6031C21.3332 18.0157 21.6282 18.4306 21.9231 18.8456C21.9503 18.8846 21.9727 18.9286 21.9974 18.9701C21.9553 19.0115 21.9033 18.9993 21.8587 18.9993C19.5761 18.9993 17.2911 18.9993 15.0086 19.0018C14.9293 19.0018 14.8624 18.9871 14.8153 18.9212C14.4634 18.4233 14.1114 17.9278 13.7595 17.4298C13.4274 16.9587 13.0929 16.4901 12.7583 16.019C12.4411 15.5748 12.1238 15.1305 11.8041 14.6863C11.7521 14.6008 11.6852 14.5252 11.6306 14.4422C11.5959 14.3958 11.5712 14.3421 11.534 14.2957Z" fill="white" fill-opacity="0.8"></path><path d="M11.4498 4.34415C11.4473 4.59069 10.3841 13.8417 10.3594 14.1029C10.347 14.2152 10.3594 14.347 10.2701 14.4471C10.1487 14.3787 10.0991 14.2518 10.0223 14.1493C9.77199 13.8124 9.5316 13.4683 9.28872 13.1241C9.0062 12.7213 7.71004 10.8955 7.33581 10.3927C7.20694 10.2145 0.525403 0.773112 0 0.0383998C0.0322181 -0.00553643 0.0817844 0.0115499 0.121437 0.0115499C2.51053 0.0115499 4.90211 0.0115499 7.2912 0.00666809C7.46716 0.00666809 7.50682 0.1458 7.56877 0.236113C7.73482 0.47044 10.5527 4.39297 10.8972 4.88604C10.9616 4.97879 10.9963 4.96659 11.0533 4.88604C11.1822 4.70053 11.3011 4.51258 11.4498 4.34415Z" fill="white" fill-opacity="0.5"></path><path d="M15.2417 9.46517C15.098 9.37241 15.0063 9.23328 14.9146 9.09659C14.8229 8.95746 14.7163 8.82565 14.6271 8.68408C14.4859 8.45951 14.3223 8.24715 14.1637 8.03235C13.9233 7.70039 13.6779 7.37331 13.4375 7.04135C13.264 6.7997 13.1005 6.55073 12.927 6.30908C12.5602 5.79893 12.1885 5.28878 11.8192 4.77863C11.7077 4.62485 11.5961 4.46863 11.4846 4.31242C11.6383 4.0488 11.8291 3.81447 12.0051 3.5655C12.2058 3.28235 12.4165 3.00409 12.6222 2.72339C12.7015 2.60622 12.7857 2.49394 12.8675 2.37922C13.2194 1.89104 13.5614 1.39798 13.9233 0.917118C14.1364 0.633973 14.3347 0.343506 14.5478 0.0603609C14.5776 0.0237473 14.6048 0.006661 14.6494 0.006661C14.6816 0.006661 14.7163 0.006661 14.7486 0.006661C17.098 0.006661 19.4474 0.006661 21.7994 0.0091019C21.8539 0.0091019 21.9332 -0.0226299 21.958 0.0335109C21.9778 0.0798881 21.9134 0.128706 21.8812 0.175083C21.3731 0.885387 20.865 1.59569 20.3595 2.30843C19.9084 2.94307 19.4623 3.58015 19.0088 4.21478C18.6098 4.77375 18.2033 5.32539 17.8018 5.88192C17.3805 6.46773 16.9667 7.05843 16.5453 7.64669C16.2727 8.02747 15.9952 8.40337 15.7275 8.78659C15.5689 9.01604 15.4078 9.2406 15.2417 9.46517Z" fill="white" fill-opacity="0.9"></path><path d="M6.75343 9.55304C6.86248 9.61162 6.90461 9.72634 6.974 9.81422C7.18961 10.0974 7.3854 10.3927 7.59358 10.6832C7.87858 11.0835 8.16855 11.4814 8.45355 11.8817C8.6543 12.1648 8.84513 12.4528 9.04835 12.736C9.40027 13.229 9.75715 13.7172 10.1115 14.2078C10.1685 14.286 10.2206 14.3665 10.2751 14.4446C10.2751 14.4763 10.2949 14.4885 10.3247 14.4934C10.1983 14.7229 10.0273 14.9206 9.87859 15.1329C9.57127 15.565 9.26396 15.9946 8.95417 16.4217C8.60721 16.8953 8.27264 17.3786 7.92072 17.8472C7.66545 18.189 7.43001 18.5453 7.18714 18.8944C7.13757 18.9627 7.07809 18.9993 6.98391 18.9993C4.70386 18.9969 2.42381 18.9969 0.143765 18.9969C0.104112 18.9969 0.0619806 19.0018 0.0148926 18.9774C0.0694155 18.8236 0.183418 18.7015 0.272637 18.5722C0.649341 18.0254 1.04091 17.486 1.43249 16.9417C1.88602 16.3143 2.34203 15.6895 2.79308 15.0597C3.31353 14.3323 3.82902 13.6001 4.34946 12.8702C4.60969 12.5041 4.87735 12.1453 5.13509 11.7791C5.48949 11.2739 5.86372 10.7784 6.21316 10.2682C6.38664 10.0241 6.55517 9.7776 6.75343 9.55304Z" fill="white" fill-opacity="0.9"></path></svg>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/shared_dossier/" + d.path}>
                                            <div className="text-dark-75 font-weight-bolder font-size-lg">
                                            {d.provider.fiscal_name}
                                            </div>
                                            <span className="text-muted font-weight-bold font-size-sm">
                                            {d.provider.rfc}
                                            <br />
                                            {d.dossier.title}
                                            </span>
                                            </a>
                                        </td>
                                        <td className="text-right">
                                            <a href={"/shared_dossier/" + d.path}>
                                                <button className="btn btn-icon btn-light btn-xs">
                                                    <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                </button>
                                            </a>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                            }
                            {this.props.dashboard=="false" &&
                            <tbody>
                            {this.state.all.map((d, index) => {
                                return <tr key={index}>
                                    <td className="pl-0 py-5">
                                        <div className="symbol symbol-40">
                                            <div className={"symbol-label text-white font-weight-bolder bg-"+this.getDossierTypeColor(d.dossier?.dossier_type_id)}>
                                                <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.534 14.2957C11.3803 14.0809 11.2242 13.8686 11.073 13.6513C11.0284 13.5854 10.9962 13.5903 10.9541 13.6464C10.7731 13.8954 10.5947 14.1468 10.4138 14.3982C10.3865 14.4373 10.3692 14.4837 10.3147 14.4959C10.2577 14.5105 10.2502 14.4788 10.2552 14.4349C10.28 14.2786 10.3221 14.1273 10.332 13.9686C10.3419 13.7758 10.3741 13.583 10.394 13.3901C10.4311 12.9874 10.4931 12.5846 10.5352 12.1819C10.5699 11.8255 10.617 11.4716 10.6542 11.1152C10.6815 10.8736 10.7013 10.6295 10.731 10.3878C10.7731 10.051 10.7979 9.70926 10.8574 9.37242C10.8896 9.19179 10.8896 9.00872 10.9119 8.8281C10.9342 8.64015 10.959 8.44976 10.9813 8.25937C11.0433 7.74189 11.0978 7.22686 11.1548 6.70939C11.1796 6.47995 11.1994 6.24806 11.2292 6.01862C11.2539 5.8087 11.2688 5.59878 11.301 5.3913C11.3332 5.20335 11.3556 5.01296 11.3655 4.82257C11.3754 4.65903 11.4076 4.50037 11.4473 4.34416C11.4596 4.33439 11.472 4.32463 11.4844 4.31487C11.5736 4.33195 11.5984 4.41494 11.6381 4.47596C11.8686 4.81281 12.1263 5.13257 12.3568 5.46941C12.6344 5.87704 12.9293 6.27491 13.2143 6.67522C13.6133 7.23419 14.0123 7.79071 14.4212 8.34236C14.5377 8.50102 14.6393 8.667 14.7583 8.82322C14.9045 9.01361 15.0185 9.22841 15.1945 9.39439C15.2168 9.41391 15.2242 9.44321 15.2391 9.46761C15.2267 9.61651 15.3506 9.69706 15.4225 9.7947C15.6777 10.1364 15.9157 10.4904 16.1684 10.8321C16.4534 11.2177 16.7409 11.601 17.0111 11.9939C17.3184 12.4406 17.643 12.8751 17.9578 13.3169C18.4287 13.9784 18.8995 14.6423 19.3729 15.3014C19.9256 16.0703 20.4832 16.8343 21.0358 17.6031C21.3332 18.0157 21.6282 18.4306 21.9231 18.8456C21.9503 18.8846 21.9727 18.9286 21.9974 18.9701C21.9553 19.0115 21.9033 18.9993 21.8587 18.9993C19.5761 18.9993 17.2911 18.9993 15.0086 19.0018C14.9293 19.0018 14.8624 18.9871 14.8153 18.9212C14.4634 18.4233 14.1114 17.9278 13.7595 17.4298C13.4274 16.9587 13.0929 16.4901 12.7583 16.019C12.4411 15.5748 12.1238 15.1305 11.8041 14.6863C11.7521 14.6008 11.6852 14.5252 11.6306 14.4422C11.5959 14.3958 11.5712 14.3421 11.534 14.2957Z" fill="white" fill-opacity="0.8"></path><path d="M11.4498 4.34415C11.4473 4.59069 10.3841 13.8417 10.3594 14.1029C10.347 14.2152 10.3594 14.347 10.2701 14.4471C10.1487 14.3787 10.0991 14.2518 10.0223 14.1493C9.77199 13.8124 9.5316 13.4683 9.28872 13.1241C9.0062 12.7213 7.71004 10.8955 7.33581 10.3927C7.20694 10.2145 0.525403 0.773112 0 0.0383998C0.0322181 -0.00553643 0.0817844 0.0115499 0.121437 0.0115499C2.51053 0.0115499 4.90211 0.0115499 7.2912 0.00666809C7.46716 0.00666809 7.50682 0.1458 7.56877 0.236113C7.73482 0.47044 10.5527 4.39297 10.8972 4.88604C10.9616 4.97879 10.9963 4.96659 11.0533 4.88604C11.1822 4.70053 11.3011 4.51258 11.4498 4.34415Z" fill="white" fill-opacity="0.5"></path><path d="M15.2417 9.46517C15.098 9.37241 15.0063 9.23328 14.9146 9.09659C14.8229 8.95746 14.7163 8.82565 14.6271 8.68408C14.4859 8.45951 14.3223 8.24715 14.1637 8.03235C13.9233 7.70039 13.6779 7.37331 13.4375 7.04135C13.264 6.7997 13.1005 6.55073 12.927 6.30908C12.5602 5.79893 12.1885 5.28878 11.8192 4.77863C11.7077 4.62485 11.5961 4.46863 11.4846 4.31242C11.6383 4.0488 11.8291 3.81447 12.0051 3.5655C12.2058 3.28235 12.4165 3.00409 12.6222 2.72339C12.7015 2.60622 12.7857 2.49394 12.8675 2.37922C13.2194 1.89104 13.5614 1.39798 13.9233 0.917118C14.1364 0.633973 14.3347 0.343506 14.5478 0.0603609C14.5776 0.0237473 14.6048 0.006661 14.6494 0.006661C14.6816 0.006661 14.7163 0.006661 14.7486 0.006661C17.098 0.006661 19.4474 0.006661 21.7994 0.0091019C21.8539 0.0091019 21.9332 -0.0226299 21.958 0.0335109C21.9778 0.0798881 21.9134 0.128706 21.8812 0.175083C21.3731 0.885387 20.865 1.59569 20.3595 2.30843C19.9084 2.94307 19.4623 3.58015 19.0088 4.21478C18.6098 4.77375 18.2033 5.32539 17.8018 5.88192C17.3805 6.46773 16.9667 7.05843 16.5453 7.64669C16.2727 8.02747 15.9952 8.40337 15.7275 8.78659C15.5689 9.01604 15.4078 9.2406 15.2417 9.46517Z" fill="white" fill-opacity="0.9"></path><path d="M6.75343 9.55304C6.86248 9.61162 6.90461 9.72634 6.974 9.81422C7.18961 10.0974 7.3854 10.3927 7.59358 10.6832C7.87858 11.0835 8.16855 11.4814 8.45355 11.8817C8.6543 12.1648 8.84513 12.4528 9.04835 12.736C9.40027 13.229 9.75715 13.7172 10.1115 14.2078C10.1685 14.286 10.2206 14.3665 10.2751 14.4446C10.2751 14.4763 10.2949 14.4885 10.3247 14.4934C10.1983 14.7229 10.0273 14.9206 9.87859 15.1329C9.57127 15.565 9.26396 15.9946 8.95417 16.4217C8.60721 16.8953 8.27264 17.3786 7.92072 17.8472C7.66545 18.189 7.43001 18.5453 7.18714 18.8944C7.13757 18.9627 7.07809 18.9993 6.98391 18.9993C4.70386 18.9969 2.42381 18.9969 0.143765 18.9969C0.104112 18.9969 0.0619806 19.0018 0.0148926 18.9774C0.0694155 18.8236 0.183418 18.7015 0.272637 18.5722C0.649341 18.0254 1.04091 17.486 1.43249 16.9417C1.88602 16.3143 2.34203 15.6895 2.79308 15.0597C3.31353 14.3323 3.82902 13.6001 4.34946 12.8702C4.60969 12.5041 4.87735 12.1453 5.13509 11.7791C5.48949 11.2739 5.86372 10.7784 6.21316 10.2682C6.38664 10.0241 6.55517 9.7776 6.75343 9.55304Z" fill="white" fill-opacity="0.9"></path></svg>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-left">
                                            <a href={"/shared_dossier/" + d.path}>
                                                <div className="text-dark-75 font-weight-bolder font-size-lg">
                                                {d.provider.fiscal_name}
                                                </div>
                                                <span className="text-dark-50 font-weight-bold font-size-sm">RFC/RUT:
                                                {d.provider.rfc}
                                                </span>
                                            </a>
                                        </td>
                                        <td className="text-left font-weight-bolder">
                                        { d.people.person_type }
                                    </td>
                                    <td className="text-left text-dark-50">
                                        { d.dossier.title }
                                    </td>
                                    <td className="text-left "> 
                                        <b>{ d.total_files }</b>  {lang.get('messages.documentos')}
                                    </td>
                                    <td className="text-right">
                                        {this.state.is_internal == true ?
                                            (this.props.permissions.documents_actions_internal.includes('download')  || this.props.permissions.documents_actions_internal.includes('all')) &&
                                            <a
                                            href={"/files/download/"+ JSON.stringify(d.ids)}
                                            target="_blank" download
                                            className="btn btn-icon btn-light btn-xs mr-5">
                                            <i className="flaticon2-download text-primary"></i>
                                            </a>
                                            :
                                            (this.props.permissions.documents_actions.includes('download')  || this.props.permissions.documents_actions.includes('all')) &&
<a
                                            href={"/files/download/"+ JSON.stringify(d.ids)}
                                            target="_blank" download
                                            className="btn btn-icon btn-light btn-xs mr-5">
                                            <i className="flaticon2-download text-primary"></i>
                                            </a>
                                        }


                                        <a href={"/shared_dossier/" + d.path}>
                                            <button className="btn btn-icon btn-light btn-xs">
                                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                            </button>
                                        </a>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                            }
                        </table>
                    </div>

                    { this.props.dashboard == "true" ?
                        <div className="text-right">
                             <a className="text-primary" href={`/clients/shared_dossiers${this.state.selectedStatusIndex !== null ? `#ts_${this.state.selectedStatusIndex}` : ''}`}>{lang.get('messages.ver_todos')}</a>
                        </div>
                    :
                        <div></div>
                    }
                </div>
                {this.state.total > this.state.maxRecords && this.props.dashboard=="false" &&
                    <SimplePagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={this.state.page}
                    totalFiles={this.state.total}
                    split={this.state.maxRecords} />
                }
            </div>
            </>
        );
    }
}

export default SharedDossiersPanel;

if (document.getElementById('SharedDossiersPanel')) {
    ReactDOM.render(<SharedDossiersPanel />, document.getElementById('SharedDossiersPanel'));
}
